import { render, staticRenderFns } from "./slotUscitaPiatti.vue?vue&type=template&id=e8489960&"
import script from "./slotUscitaPiatti.vue?vue&type=script&lang=js&"
export * from "./slotUscitaPiatti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports